module.exports = __webpack_public_path__ + "static/media/bg5.e78ee2e7.png";